import React from "react";
import { Pressable, Text } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Margin } from "../buttons/roundedButton/RoundedButton";
import { GlobalStyles, Transition } from "../style/Style";

interface ButtonProps {
    buttonText: string;
    width?: number;
    height?: number;
    isActive: boolean;
    disabled: boolean;
    margin: Margin;
    testID?: string;
    onPress: () => void;
    reviewPicksState?: boolean;
}

export const PickEmButton: React.FC<ButtonProps> = ({
    buttonText,
    width,
    height,
    isActive,
    disabled,
    margin,
    onPress,
    testID,
    reviewPicksState,
}) => {
    let adjustedHeight = 26; // default inner height
    if (height) {
        adjustedHeight = height - 2 * parseInt(EStyleSheet.value(GlobalStyles.BORDER_THICKNESS), 10); // height of button - 2*border thickness px padding
    }
    const styles = useDynamicStyles(() => GenerateStyles(adjustedHeight, margin));
    const containerWidth = width ? { maxWidth: width } : {};
    const containerHeight = height ? { maxHeight: height } : {};

    return (
        <Pressable
            testID={testID}
            style={[
                styles.button,
                containerWidth,
                containerHeight,
                isActive && styles.activeButtonColor,
                disabled && styles.disabledButtonColor,
                Transition(),
            ]}
            disabled={reviewPicksState || disabled}
            onPress={onPress}
        >
            <Text style={[styles.text, isActive && styles.activeTextBorder]}>{buttonText}</Text>
        </Pressable>
    );
};

const GenerateStyles = (adjustedHeight: number, margin?: Margin) => {
    return EStyleSheet.create({
        button: {
            flex: 1,
            width: "100%",
            borderColor: "transparent",
            color: () => EStyleSheet.value(GlobalStyles.PROP_PICKEM_TEXT),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.PROP_SELECTED),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BUTTON_RADIUS),
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
            textAlign: "center",
            height: 30,
            fontSize: 16,
            maxWidth: 120,
            marginLeft: margin?.left !== undefined ? margin.left : 0,
            marginRight: margin?.right !== undefined ? margin.right : 0,
            marginTop: margin?.top !== undefined ? margin.top : 0,
            marginBottom: margin?.bottom !== undefined ? margin.bottom : 0,
            justifyContent: "center",
        },
        text: {
            borderColor: "transparent",
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BUTTON_RADIUS),
            fontSize: "inherit",
            color: "inherit",
            height: adjustedHeight,
            lineHeight: adjustedHeight,
            fontFamily: "inherit",
        },
        activeTextBorder: {
            borderColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
        },
        activeButtonColor: {
            borderColor: () => EStyleSheet.value(GlobalStyles.PROP_SELECTED),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.PROP_SELECTED_BACKGROUND),
            color: () => EStyleSheet.value(GlobalStyles.PROP_SELECTED_TEXT),
        },
        disabledButtonColor: {
            backgroundColor: () => EStyleSheet.value(GlobalStyles.DISABLED_BUTTON),
            color: () => EStyleSheet.value(GlobalStyles.DISABLED_TEXT),
        },
    });
};
